import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import PropTypes from 'prop-types';
import AnalyticsDimensionSingleton from '../../components/Header/AnalyticsDimensionSingleton';
import Assets from '../../requests/apa/Asset';
import { TITLE_MODAL_PROMOTIONS } from '../../AAF/Auth/authConstants'
import logger from 'src/utils/logger/logger';

const ModalPromotion = (props = {}) => {
    const content = Translator.get('promotions_access_text_html',  '');

    if(typeof props.setMetricsEvent === 'function'){
        const sendDimension=()=>{
          const payload=new AnalyticsDimensionSingleton().getPayload();
          props.setMetricsEvent(payload);
          props.setMetricsEvent({ type: 'executor'});
        };
        const sendMetric=()=>{
          props.setMetricsEvent({
            hitType: 'event',
            eventCategory: 'errores',
            eventAction: TITLE_MODAL_PROMOTIONS,
            eventLabel: content,
          });
          props.setMetricsEvent({type:'executor'});
          sendDimension();
        };
        sendMetric();
      }
      const customizedClassName =`modal-button-return`;
      const p = {
        content,
        asset: null,
        alwaysEnabled: true,
        handleBackKey: props.handleBackKey ? props.handleBackKey : null,
        buttons: [
          {
            content: Translator.get('promotions_access_option_button_close', 'ACEPTAR'),
            props: {
              onClick: (e) => {props.handleClose(e, props.callback);},
              className: 'modal-button-primary',
              handleMouseEnter: (e) => props.handleMouseEnter(e),
              id: 'btnPromotionAccept'
            }
          }

        ],
        colorButtons: [
           {
            content: Translator.get('top_head_option_button_back', 'REGRESAR'),
            props: {
              color: 'yellow',
              className: customizedClassName,
              imgSrc: Assets.get('top_head_option_back', ''),
              onClick: (e) => props.handleClose(e, props.callback),
              handleMouseEnter: (e) => props.handleMouseEnter(e),
              id: 'btnPromotionYellow'
            }
           }
          ],
        aafNewStyle: true,
        className: 'modal-promotion-telcel-telmex'
      };
      if(props.title) p.title = title;
      return <ModalWrapper {...p} />;
    };

ModalPromotion.propTypes = {
  content: PropTypes.object,
  callback: PropTypes.func,
  className: PropTypes.string
};

ModalPromotion.defaultProps = {
  content: {
    code: 'modal_msg_error_default',
    message: 'Por favor vuelve a intentarlo'
  },
  callback: () => { logger.debug('callback...') }
};

export default withOnClose(ModalPromotion);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalPromotion.jsx